import React from 'react';
import { Page } from './page';

import Player from '../functions/player';

import { EntitiesArray } from '../components/island';
import { Score } from '../components/score';
import { GameInfo } from '../components/gameInfo';
import { Restore } from '../components/restore';

var reload = false;

export class RoundSwitch extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      partOfGame: 4,
      timerOver: false,
      scoresList: ""
    }

    this.nextRound = this.nextRound.bind(this);
  }

  nextRound() {
    this.refs.GameInfo.nextRound();
    reload = false;
    return;
  }

  renderScores(){
    var scores = [];
    const restoredFromCurrent = Player.getData('roundSwitch');
    console.log("Rendering scores", restoredFromCurrent, reload, EntitiesArray);
    // console.log("Debug", EntitiesArray[0].round);
    if (!restoredFromCurrent && !reload) {
      reload = true;
      for (var d = 0; d < EntitiesArray.length; d++) {
        const hasPosition = !!(EntitiesArray[d].displayPosition || EntitiesArray[d].displayPosition === 0);
        scores.push(<Score show={true} endscore={hasPosition} key={'key_' + d } dataKey={d} data={EntitiesArray[d]}/>);
      }

    } else {
      for (var i = 0; i < EntitiesArray.length; i++) {
        scores.push(<Score show={true} endscore={true} hideNumber={true} key={'key_' + i } dataKey={i} data={EntitiesArray[i]}/>);
      }
    }

    return scores;
  }

  componentDidMount(){
//    this.refs.GameInfo.instantUpdate();

    const scores = this.renderScores();
    this.setState({
      scoresList: scores,
    })
  }

  componentWillMount() {
    var currentLocation = this.props.location.pathname;
    Player.storeData('localRoute', currentLocation);

    const newPart = Player.getData('partOfGame');

    this.setState({
      partOfGame: newPart,
    });
  }

  render(){
    return(
      <Page width="superWide" pageTitle={"Ronde " + (Player.getData("round") === undefined ? 1 : Player.getData("round"))}>
      <Restore />
        <div className="roundSwitch">
          { this.state.scoresList }
        </div>
        <div className="roundSwitch-buttons">
          <GameInfo ref="GameInfo" part={this.state.partOfGame} getGameScreen={() => {return this.props.location.pathname}} />
          <button className="btn_roundswitch bigButton" onClick={this.nextRound}>Volgende</button>
        </div>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/roundswitch.js